import { axios } from '@/utils/request'

// 提现管理 - 预加载
export function getWithdrawalPre(parameter) {
  return axios({
    url: '/merchant.php/withdrawal/pre',
    method: 'get',
    params: parameter
  })
}

// 提现管理 - 提交提现申请单
export function postWithdrawalAdd(data) {
  return axios({
    url: '/merchant.php/withdrawal/add',
    method: 'post',
    data: data
  })
}

// 提现管理 - 提现列表
export function getWithdrawalList(parameter) {
  return axios({
    url: '/merchant.php/withdrawal/getList',
    method: 'get',
    params: parameter
  })
}
